export class DomUtil {
    public static translatePosition($element: JQuery): { x: number; y: number } {
        const matrix = $element.css("-webkit-transform");
        // eslint-disable-next-line no-useless-escape
        const matrixMatch = matrix.match(/-?[\d\.]+/g);
        if (matrixMatch == null) return { x: 0, y: 0 };

        return {
            x: parseFloat(matrixMatch[4]),
            y: parseFloat(matrixMatch[5]),
        };
    }

    public static momentumResistance(overdrag: number, range: number): number {
        if (overdrag === 0) return 0;

        const x = (1 / range) * overdrag;
        const c = Math.pow(Math.E, -x);
        const resistance = (1 - c) / (1 + c);
        return -overdrag + resistance * range;
    }

    static scrollTo($scrollContainer: JQuery, offset: JQuery | number, finished?: { () }, useAnimation?: boolean) {
        let topPosition = 0;

        if (offset["length"] !== undefined) topPosition = (offset as JQuery).position().top;
        else topPosition = offset as number;

        //scroll a bit above it
        topPosition -= 6;

        if (topPosition < 0) topPosition = 0;

        if (useAnimation === undefined || useAnimation === true) {
            $scrollContainer.one("mousedown wheel DOMMouseScroll mousewheel keyup touchmove", () => {
                $scrollContainer.stop();
            });

            $.when($scrollContainer.animate({ scrollTop: topPosition }, 600, "easeOutExpo")).then(() => {
                if (finished !== undefined) finished();

                $scrollContainer.off("mousedown wheel DOMMouseScroll mousewheel keyup touchmove");
            });
        } else {
            $scrollContainer.scrollTop(topPosition);
        }
    }
}
